
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mintNFT",
      function () {
        return require("private-next-pages/mintNFT/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mintNFT"])
      });
    }
  